<template>
  <article class="inquiry_art">
    <p class="num-dealers">预计有<span class="num">{{this.numDealers || 0}}</span>位车商收到本车询价邀请</p>
    <group>
      <selector title="询价时长" v-model="queryForm.period_type" placeholder="请选择" :options="inquiryTime"></selector>
      <datetime title="交车日期" v-model="queryForm.deal_date" placeholder="请选择首次上牌日期" :min-year="1970" :start-date="startDate" format="YYYY-MM-DD" confirm-text="完成" cancel-text="取消" class="datetime"></datetime>
    </group>
    <p class="inqury_note">注：询价开始时间为当前时间。</p>
    <section class="btn-bottom">
      <div class="btn-fix">
        <p class="protocol-hint">
          <span>提交询价即代表阅读并同意</span>
          <router-link to="/protocol/inquiry">询价协议</router-link>
        </p>
        <a class="btn" @click.stop="onSubmit">去询价</a>
      </div>
    </section>
  </article>
</template>
<script>
import {
  Group,
  Selector,
  Datetime
} from '@lx-frontend/cvux'
import util from '../../common/util'
export default {
  components: {
    Group,
    Selector,
    Datetime
  },
  data() {
    return {
      isClicked: false,
      startDate: util.formatTime(new Date(), 'yyyy-MM-dd'),
      inquiryTime: [
        { key: '1', value: '15分钟' },
        { key: '2', value: '30分钟' },
        { key: '3', value: '45分钟' },
        { key: '4', value: '60分钟' },
        { key: '5', value: '2小时' },
        { key: '6', value: '4小时' },
        { key: '7', value: '12小时' }
      ],
      urlLeft: '',
      source: '',
      numDealers: 0,
      queryForm: {
        period_type: '', // # 询价时长 查看询价时长列表
        deal_date: '' // # 交车时间
      }
    }
  },
  created() {
    // 取消车商选择
    let id = this.$route.params.id
    let carType = 1
    this.source = this.$route.params.source
    if (this.source === 'inquiry') { // 线索询价
      carType = 1
      this.urlLeft = `used_car/ticket/${id}/enquiry`
    } else if (this.source === 'auction') { // 拍卖询价
      carType = 2
      this.urlLeft = `auctions/submit_auction_car_enquiry/${id}`
    }
    this.queryForm.deal_date = this.startDate
    // 获取收到报价邀请的车商数
    // 来源car_type=1为线索 car_type=2为车辆
    this.$rest.usedCar.getTaggedDealers(null, `${id}/tagged_dealers?car_type=${carType}`).then(res => {
      if (res.code === 0) {
        this.numDealers = res.data.num_dealers
      } else {
        this.showToast(res.message)
      }
    })
    // 晚上9点到早上7点，只能选择询价时长为12小时
    const hour = new Date().getHours()
    if (hour >= 21 || hour <= 6) {
      this.inquiryTime = [
        { key: '7', value: '12小时' }
      ]
    }
  },
  methods: {
    getError() {
      let obj = {
        valid: true,
        msg: ''
      }
      if (!this.queryForm.period_type) {
        obj.valid = false
        obj.msg = '请选择询价时长'
      }
      return obj
    },
    onSubmit() {
      if (this.isClicked) {
        return false
      }
      let error = this.getError()
      if (error.valid) {
        this.isClicked = true // 防止请求一次后，多次请求
        let params = this.queryForm
        params = Object.assign({}, params, {
          period_type: +params.period_type
        })
        // delete params.dealer_user_name
        this.$rest.inquiry.submitEnquiry(params, this.urlLeft).then(res => {
          if (res.code === 0) {
            this.isClicked = false
            // cache.clearSessionData(this.submitKey)
            // TODO: 父子路由的前缀通过上一个页面的参数传递
            let isParentRouter = this.$route.matched[0].path === '/auction/carmanage'
            let prefix = isParentRouter ? '/auction/carmanage' : ''
            this.$router.push({
              // path: `/auction/carmanage/inquiry/success/${res.data.enquiry_id}/${this.source}`,
              path: `${prefix}/inquiry/success/${res.data.enquiry_id}/${this.source}`,
              query: {
                'finished_at': res.data.finished_at,
                'period_type': params.period_type
              }
            })
          } else {
            this.isClicked = false
            this.showToast(res.message)
          }
        })
      } else {
        if (error.msg) {
          this.showToast(error.msg)
        }
      }
    }
  }
}

</script>
<style lang="less">
@import '../../stylesheets/base/fn';
.inquiry_art {
  .datetime .vux-datetime-value {
    color: #000;
  }
  .inqury_note {
    margin: 20/@w2 30/@w2;
    color: #000;
    opacity: 0.4;
  }
  .num-dealers{
    margin-top: 17/@w;
    text-align: center;
    color: #454545;
    .num{ color: #d0021b;}
  }
  .protocol-hint {
    position: absolute;
    top: -80/@w2;
    left: 0;
    padding: 20/@w2 30/@w2;
    font-size: 0;
    a, span {
      font-size: 26/@w2;
    }
    a {
      color:#3b5999;
    }
  }
}
</style>
